var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-top-bar',{attrs:{"menu":_vm.menu,"color":'linear-gradient(135deg, #00345F 0%, #0066B3 100%)',"moduleName":'RESULTS MODULE'}}),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }